import React from 'react';
import ThirdPartyCookiesBlockedStatusModal from '../features/thirdparty-cookies/components/ThirdPartyCookiesBlockedStatusModal/ThirdPartyCookiesBlockedStatusModal';

const Home = () => <ThirdPartyCookiesBlockedStatusModal />;

export default Home;
